import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import useDisableHelp from "../../../../Hooks/useDisableHelp";
import afterLoginApiAxios from "../../../../Util/API Calls/afterLogin";
import DoctorContext from "../../../ClinicComponents/ClinicWrapper/DoctorContext";
import CustomSelect from "../../../UI Component/CustomSelect/CustomSelect";
import Loader from "../../../UI Component/Loader/Loader";
import { VIEW_CALENDAR } from "../Constants";
import MyScheduleFeesContext from "../MyScheduleFeesContext";
import DatePicker from "./DatePicker";
import SlotDateSelector from "./SlotDateSelector";
import Slots from "./Slots";
import ViewLogs from "../ViewLogs";
import { APPLICABLE_ROLE } from "../../../DashboardAppointmentsView/Constant";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { USER_ROLE } from "../../../../Util/constants";
import { C2CConsole } from "../../../../Util/Helper/C2CConsole";

export default function ViewCalendarDetails(props) {
  const { staffDoctor, callProcedureApi, isResourceArray, dropdownOptionsList } = props;
  const myScheduleFeesContext = useContext(MyScheduleFeesContext);

  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [selectedSlotIds, setSelectedSlotIds] = useState([]);
  const [selected_date, setSelectedDate] = useState(
    moment().format("yyyy-MM-DD")
  );
  const [selectedCalenderDate, setselectedCalenderDate] = useState({});
  const [fromCalender, setFromCalender] = useState(false);
  let [track, changeTrack] = useState(1);
  const [addClass, setaddClass] = useState("");
  const [selectorDate, setSelectorDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [counter, setcounter] = useState(0);
  const [contentLoading, setContentLoading] = useState(false);
  const doctor_context = useContext(DoctorContext);

  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  const staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );
  const doctId =
    localStorage.getItem("staff_selected_dr") &&
    JSON.parse(localStorage.getItem("staff_selected_dr"));
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);

  useDisableHelp();
  useEffect(() => {
    setDropdownOptions(myScheduleFeesContext.consultationTypes);
    if (myScheduleFeesContext.selectedConsultationType.value == 4) {
      myScheduleFeesContext.setSelectedConsultationType(
        myScheduleFeesContext.consultationTypes[0]
      );
    }
  }, [myScheduleFeesContext.consultationTypes]);

  //use effect to get procedure;
  useEffect(() => {
    getProcedure();
  }, []);

  useEffect(() => {
    if (callProcedureApi) {
      getProcedure();
    }
  }, [callProcedureApi]);

  //function to get the procedure list
  function getProcedure() {
    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      afterLoginApiAxios({
        method: "post",
        url: "/clinic/get-procedure",
        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: {
          doctor_id:
            doctorRole == USER_ROLE.DOCTOR_ADMIN ||
              doctorRole === USER_ROLE.RESOURCE_ADMIN ||
              userType == APPLICABLE_ROLE.STAFF
              ? doctId
                ? doctId.doctor_id
                : staffDoctor.id
              : userId,
          clinic_id: doctor_context?.clinic_id,
        },
      })
        .then((response) => {
          let arr =
            localStorage.getItem("isResourceArray") === "True" ||
              doctorRole === USER_ROLE.RESOURCE_CONSULTANT
              ? []
              : [...myScheduleFeesContext.consultationTypes];
          if (response.data.statusCode == 200) {
            if (response.data.procedure_details.length > 0) {
              response.data.procedure_details.map((ele) => {
                ele["value"] = ele.id;
                ele["id"] = "4";
                ele["label"] = ele.procedure_name;
                arr.push(ele);
              });
            }
            setDropdownOptions(arr);
          } else {
            if (
              isResourceArray === "True" ||
              doctorRole === USER_ROLE.RESOURCE_CONSULTANT
            ) {
              myScheduleFeesContext.setSelectedConsultationType({
                label: "No  Procedure added",
              });
              setDropdownOptions(arr);
            }
          }
        })
        .catch((error) => {
          C2CConsole.error(error);
        });
    } else {
      afterLoginApiAxios({
        method: "post",
        url: "/doctor/get-procedure",
        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: {
          doctor_id:
            userType === APPLICABLE_ROLE.DOCTOR
              ? userId
              : doctId
                ? doctId.doctor_id
                : staffDoctor.id,
        },
      })
        .then((response) => {
          let arr = [...myScheduleFeesContext.consultationTypes];
          if (response.data.statusCode == 200) {
            if (response.data.procedure_details.length > 0) {
              response.data.procedure_details.map((ele) => {
                ele["value"] = ele.id;
                ele["id"] = "4";
                ele["label"] = ele.procedure_name;
                arr.push(ele);
              });
              setDropdownOptions(arr);
            }
          }
        })
        .catch((error) => {
          C2CConsole.error(error);
        });
    }
  }

  function handleOnChange(option) {
    myScheduleFeesContext.setSelectedConsultationType(option);
  }

  function handleUpdateSchedule() {
    addSlots(selectedSlotIds);
  }

  const addSlots = (slots) => {
    let api_url = "";
    let payload = {};
    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      api_url = "/clinic/update-slots-by-slot-id";
      payload = {
        doctor_id:
          doctorRole == USER_ROLE.DOCTOR_ADMIN ||
            doctorRole === USER_ROLE.RESOURCE_ADMIN ||
            userType == APPLICABLE_ROLE.STAFF
            ? staffDoctor.id
            : userId,
        clinic_id: doctor_context?.clinic_id,
        user_agent: "web",
        user_id: userType === APPLICABLE_ROLE.DOCTOR ? userId : staffId,
        user_type:
          userType === APPLICABLE_ROLE.DOCTOR
            ? 1
            : userType === APPLICABLE_ROLE.STAFF && 4,
      };
    } else {
      api_url = "/doctor/update-slots-by-slot-id";
      payload = {
        doctor_id:
          userType === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
        user_agent: "web",
        user_id: userType === APPLICABLE_ROLE.DOCTOR ? userId : staffId,
        user_type:
          userType === APPLICABLE_ROLE.DOCTOR
            ? 1
            : userType === APPLICABLE_ROLE.STAFF && 4,
      };
    }
    setContentLoading(true);
    afterLoginApiAxios({
      method: "post",
      url: api_url,
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        slots: slots,
        ...payload,
      },
    })
      .then((response) => {
        if (response.data.statusCode == 200) {
          setcounter(counter + 1);
          setSelectedSlotIds([]);
          setContentLoading(false);
        }
      })
      .catch((error) => {
        C2CConsole.error(error);
        setContentLoading(false);
      });
  };

  function handleSelectedSlotCallback(selectedSlotId) {
    let slotsSelected = [];
    if (selectedSlotIds.includes(selectedSlotId)) {
      slotsSelected = selectedSlotIds.filter(
        (currentId) => currentId !== selectedSlotId
      );
    } else {
      slotsSelected = [...selectedSlotIds, selectedSlotId];
    }
    setSelectedSlotIds(slotsSelected);
  }

  function handleDateChange(date) {
    setSelectedDate(moment(date).format("yyyy-MM-DD"));
    setFromCalender(true);
    changeTrack(++track);
  }

  const selectDateHandler = (date) => {
    setselectedCalenderDate(date);
    setSelectedDate(moment(date.meta._d).format("yyyy-MM-DD"));
    setSelectorDate(date.meta._d);
  };

  return loading ? (
    <Loader />
  ) : (
    <section className="myschedulefees-viewcalendar">
      <div className="row d-flex flex-row align-items-lg-center align-items-start px-3">
        <div className="col-lg-7 col-12 d-flex flex-lg-row flex-column align-items-lg-center align-items-start justify-content-start mt-3 pb-4 consult-select view-calander-dropdown">
          <span className="mr-lg-3 mb-lg-0 mb-2 text-left font-weight-bold consult-type">
            {isResourceArray === "True" ||
              doctorRole === USER_ROLE.RESOURCE_CONSULTANT
              ? "Procedure"
              : "Consultation Type"}
          </span>
          <CustomSelect
            showSearch={true}
            options={dropdownOptions}
            placeholder={""}
            value={myScheduleFeesContext.selectedConsultationType}
            handleChange={handleOnChange}
            className="select_dropdownOptions"
            isSearchable={false}
          />
        </div>
        <div className="col-lg-5 col-12">
          <div style={{ display: "flex", justifyContent: "right" }}>
            <DatePicker
              selectorDate={selectorDate}
              handleDateChange={handleDateChange}
            />
            <div
              className="view-logs-title ml-5"
              onClick={() => {
                if (window.innerWidth > 767) {
                  setaddClass("btm-drawer");
                  props.setShowBackDrop("btm-drawer");
                  props.handleViewLogOpened(true);
                } else {
                  props.setShowLogsMobile(true);
                }
              }}
            >
              View Logs
            </div>
          </div>
          {/* TODO: Add Calendar widget here and handle change */}
        </div>
      </div>
      <div className="pt-3">
        <SlotDateSelector
          onSelect={selectDateHandler}
          selectedDate={selectedCalenderDate}
          fromCalender={fromCalender}
          calenderDate={selected_date} //calenderDate
          track={track}
        />
      </div>
      <div className="row mt-3" style={{ height: "300px" }}>
        <div className="col-12 px-3">
          {contentLoading ? (
            <Loader />
          ) : (
            <>
              <div className="view-calendar">
                <Slots
                  doctorId="TODO"
                  selected_date={selected_date}
                  consultation_typeId={
                    myScheduleFeesContext.selectedConsultationType
                  }
                  procedureId="TODO"
                  getSelectedSlotCallback={handleSelectedSlotCallback}
                  counter={counter}
                  staffDoctor={staffDoctor}
                />
              </div>
              <div className="row mt-5 update_btn">
                <div className="col-12 py-3 text-center border-top border-left-0">
                  <button
                    className="btn btn-update-schedule rounded-pill"
                    onClick={handleUpdateSchedule}
                  >
                    Update Schedule
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <ViewLogs
        addClass={addClass}
        setAddClass={() => {
          props.handleViewLogOpened();
          setaddClass("");
          props.setShowBackDrop("");
        }}
        logType={VIEW_CALENDAR}
        procedureDropDown={dropdownOptionsList}
        roleNameMenu={props.roleNameMenu}
        staffDoctor={staffDoctor}
        tableData={props.tableData}
        handleViewLogOnFilter={props?.handleViewLogOnFilter}
        logFilterData={props?.logFilterData}
        totalRecords={props?.totalRecords}
      ></ViewLogs>
    </section>
  );
}
